import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { ActionButton, MessageBar, MessageBarType, ProgressIndicator, Stack, } from '@fluentui/react';
import { useSignOutFunction } from '@msrceng/auth';
import { InteractionStatus } from '@azure/msal-browser';
/** MessageBar that displays when a user login is in progress */
export const MessageSignIn = ({ label = 'Signing you in, please wait...', buttonLabelCancel = 'Sign out', }) => {
    const { inProgress } = useMsal();
    const onSignOut = useSignOutFunction();
    if (inProgress !== InteractionStatus.Login) {
        return null;
    }
    return (_jsx(UnauthenticatedTemplate, { children: _jsx(MessageBar, Object.assign({ messageBarType: MessageBarType.info, styles: { innerText: { width: '100%' } } }, { children: _jsx("div", { children: _jsx(ProgressIndicator, { label: _jsxs(Stack, Object.assign({ horizontal: true, horizontalAlign: 'space-between' }, { children: [label, _jsx(ActionButton, Object.assign({ iconProps: { iconName: 'Cancel' }, onClick: () => onSignOut() }, { children: buttonLabelCancel }))] })), ariaValueText: label }) }) })) }));
};
